import React, { createContext, useContext, useReducer } from "react";
import { reducer } from "./reducer";
import { initialState } from "./initialState";
const AppContext = createContext();

const Context = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <AppContext.Provider
      value={{
        //states
        state,
        dispatch,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
const Globalstate = () => useContext(AppContext);

export { Context, Globalstate, AppContext };
